// i18n area 'apps' — locale nl-NL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.nl-NL.meta.json.
import type { enUS } from './apps'

export const nlNL: typeof enUS = {

  // Apps golf 1 (Annex R): beheerde podman-containers — bewaakt door de worker
  // op een gedeclareerde node; image = lockfile branch@digest (Annex Q) met
  // policy pinned/tracking; untagged L3-aansluiting met statisch IP.
  apps: {
    title: 'Apps',
    create: 'App aanmaken',
    createTitle: 'App aanmaken',
    editTitle: 'App bewerken',
    name: 'Naam',
    nameHint: 'DNS-1123, uniek binnen de scope — onveranderlijk na aanmaak.',
    node: 'Node',
    nodeHint: 'De lidnode die hem draait — expliciete placement (de scheduler komt later).',
    image: 'Image',
    editImageHint: 'Een nieuwe referentie wordt opnieuw opgelost via de stamgegevens — dat is de handeling voor pin en rollback.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'De digest verschuift alleen op commando.',
    policyTrackingHint: 'Automatische rolling zodra een refresh de branch verschuift.',
    archMovePolicy: 'Cross-arch verplaatsing',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Wat er gebeurt als de app naar een node van een andere architectuur wordt VERPLAATST: refuse weigert de verplaatsing, reresolve lost het lockfile opnieuw op vanaf de branch op de nieuwe arch — de inhoud verandert, en het antwoord noemt de digest-wijziging.',
    network: 'Netwerk',
    networkHint: 'Untagged L3-aansluiting: een logisch fabric-netwerk (aanbevolen — gateway en DNS uit de enige bron), een overlay, of een kale host-bridge (afgeraden).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'host-bridge:',
    ipAssignment: 'IP-toewijzing',
    ipStatic: 'Statisch',
    ipAuto: 'Automatisch (IPAM)',
    ipAssignmentHint_static: 'Het adres geef je zelf op, nu.',
    ipAssignmentHint_auto: 'IPAM kiest een vrij adres uit de aan TVirt voorbehouden ranges van het netwerk.',
    bridgeDiscouraged: 'Kale host-bridge — AFGERADEN: TVirt weet niets van de adressering ervan, dus gateway en DNS moet je met de hand opgeven. De aanbevolen weg is een logisch fabric-netwerk.',
    ip: 'IP',
    ipHint: 'Statisch IPv4 binnen het subnet van de aansluiting.',
    ipCidrHint: 'In CIDR-vorm op een kale bridge (bijv. 192.168.1.10/24) — er is niets om de prefix uit af te leiden.',
    gateway: 'Gateway',
    gatewayManualHint: 'Handmatig — een kale bridge leidt niets af.',
    dnsServers: 'DNS-servers',
    dnsManualHint: "Handmatig, gescheiden door komma's — minstens één.",
    rootKind: 'Root',
    rootEphemeral: 'vluchtig',
    rootPersistent: 'persistent',
    rootEphemeralHint: 'Bij elke hercreatie opnieuw uit de image opgebouwd; leeft op de vluchtige storage van het cluster.',
    rootEphemeralHintNamed: 'Bij elke hercreatie opnieuw uit de image opgebouwd; leeft op de vluchtige storage van het cluster ({name}).',
    rootPersistentHint: 'Overleeft herstarts; leeft op de storage die je kiest.',
    rootStorage: 'Root-storage',
    editRootStorageHint: 'De root wordt opnieuw opgebouwd op de nieuwe pool — bestaande gegevens verhuizen NIET vanzelf.',
    volumes: 'Volumes',
    volumeAdd: 'Volume toevoegen',
    volumeName: 'Naam',
    volumeMountPath: 'Mountpad',
    volumeKind: 'Type',
    volumeStorage: 'Storage',
    devices: 'Apparaten',
    deviceClassHint: 'Je vraagt om een KLASSE (een gpu-device- of usb-device-tag), nooit een specifiek apparaat: de opgegeven node moet er een hebben die voor de Apps is gemarkeerd. Meerdere Apps kunnen hetzelfde apparaat gebruiken — een container deelt het, hij neemt het niet weg bij de host.',
    deviceSlot: 'Slot',
    deviceTag: 'Tag',
    deviceValue: 'Klasse',
    deviceUnresolved: 'er wordt nu niets opgelost',
    noDeviceTags: 'Nog geen tag van soort gpu-device of usb-device: maak er een en wijs die toe aan de apparaten die voor de Apps zijn gemarkeerd.',
    env: 'Omgeving',
    envHint: 'Eén SLEUTEL=waarde per regel.',
    secretEnvTitle: 'Geheime variabelen',
    secretEnvNotice: 'Een geheime waarde komt nooit meer terug uit de API: niemand leest hem opnieuw, ook niet wie hem heeft geschreven. In het checkpoint reist hij verzegeld met de masterpass, dus een herstel zonder masterpass vraagt hem opnieuw in te typen.',
    secretEnvPromote: 'Maak een van de hierboven geschreven variabelen geheim:',
    secretEnvAdd: 'Geheime variabele toevoegen',
    secretEnvName: 'Naam',
    secretEnvValue: 'Waarde',
    secretEnvKept: 'behouden — laat leeg om hem niet te wijzigen',
    secretEnvWithdrawWarning: 'Om een variabele die al geheim is niet langer als geheim te behandelen, schrijf er een nieuwe waarde voor: alleen de markering intrekken zou een manier zijn om te LEZEN wat de store nooit verlaat. Hem verwijderen wist hem daarentegen.',
    secretEnvChip: 'geheim',
    startNow: 'Meteen starten (anders wordt de app gestopt aangemaakt)',
    deletePersistentIntro: 'Deze app heeft persistente gegevens — kies wat ermee moet gebeuren:',
    deleteKeepData: 'Gegevens behouden (de mappen blijven verweesd op hun storage achter)',
    deletePurgeData: 'Ook de gegevens verwijderen',
    phase: 'Fase',
    phase_running: 'Draait',
    phase_stopped: 'Gestopt',
    phase_error: 'Fout',
    phase_unknown: 'Onbekend',
    desiredState: 'Gewenst',
    wantedRunning: 'draaiend',
    wantedStopped: 'gestopt',
    start: 'Starten',
    stop: 'Stoppen',
    restart: 'Herstarten',
    refreshImage: 'Image bijwerken (neemt de nieuwe @current over)',
    logs: 'Logs',
    logsTitle: 'Logs',
    logsEmpty: 'Geen output vastgelegd.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'De App draait niet — een shell heeft een levende container nodig. De logs zijn in elke toestand leesbaar.',
    shellConnect: 'Verbinden',
    shellDisconnect: 'Verbreken',
    shellExited: 'De sessie is beëindigd met exitcode {code}.',
    shellEndedWithoutStatus: 'De sessie is beëindigd zonder exitstatus: {reason}',
    shellRevoked: 'Het ticket van de sessie is niet meer geldig — het is verlopen, of de login die het opende is ingetrokken.',
    shellHint: 'Klik in het zwarte vlak en typ: de toetsen gaan naar de container. Ctrl+C en de pijltjes werken; exit sluit de shell.',
    shellStatus: {
      connecting: 'Verbinden…',
      connected: 'Verbonden',
      ended: 'Beëindigd'
    },
    deleteRunningError: 'Voor {name} is draaiend de gewenste staat — stop hem eerst.',

    // Standaarddialoog (ronde #156): de tabbladen van het detail en de
    // ontbrekende contractvelden — elk veld van de App zichtbaar, sloten met
    // het waarom erbij.
    tabs: {
      general: 'Algemeen',
      image: 'Image',
      network: 'Netwerk',
      storage: 'Storage',
      devices: 'Apparaten',
      observed: 'Waargenomen'
    },
    attachment: 'Aansluiting',
    runningDigest: 'Draaiende digest',
    lastError: 'Laatste fout',
    reportObservedAt: 'Laatste rapport van de worker',
    desiredStateLock: 'Wordt bestuurd door de acties Starten en Stoppen — nooit door een directe wijziging.',
    ipEditDisabledHint: 'Alleen te wijzigen bij statische toewijzing.',
    derivedFromNetworkHint: 'Afgeleid uit de enige bron van het netwerk — handmatig alleen op een kale bridge met statisch IP.',
    ephemeralUnset: 'niet geconfigureerd',
    ephemeralMissing: 'De vluchtige storage van de Apps is niet geconfigureerd — een app met vluchtige onderdelen (root of volumes) aanmaken wordt geweigerd zolang je die niet instelt.',
    ephemeralCurrent: 'Vluchtige storage van de Apps: {name}',
    ephemeralMissingCreate: 'Deze app heeft vluchtige onderdelen, maar de vluchtige storage van de Apps is niet ingesteld — de aanmaak wordt geweigerd. Stel die eerst in via de banner op de pagina Apps.',
    setEphemeral: 'Vluchtige storage instellen',
    changeEphemeral: 'Vluchtige storage wijzigen',
    setEphemeralTitle: 'De vluchtige storage van de Apps instellen',
    changeEphemeralTitle: 'De vluchtige storage van de Apps wijzigen',
    ephemeralStorageHint: 'Cluster-DEFAULT: de dir-achtige pool waar de roots en de vluchtige volumes van elke app leven, tenzij de app zelf een override declareert. Een wijziging gaat niet warm in en herstart niets: hij geldt vanaf de volgende start van elke app — vluchtige gegevens verhuizen niet.',
    ephemeralPool: 'Storage-pool',
    ephemeralOverride: 'Vluchtige storage (override per app)',
    ephemeralOverrideInherit: 'Neemt de cluster-default over',
    ephemeralOverrideInheritNamed: 'Neemt de cluster-default over ({name})',
    ephemeralOverrideHint: 'Pool per app voor root en vluchtige volumes — laat leeg om de cluster-default over te nemen. Wijzigen gaat niet warm in en herstart niets: het geldt vanaf de volgende start (vluchtige gegevens worden leeg herboren op de nieuwe pool) en vereist het recht app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Alle branches',
    imageBranchHint: 'Beperkt de images tot die welke deze branch noemt; zonder branch zie je alle images van het repository.',
    imageDigestHint: 'De inhoud: gekozen uit de digest-tabel, die de herkomst en de architectuur meedraagt. Dezelfde branch biedt er één per architectuur, en ze zijn niet uitwisselbaar.',
    imageLockfile: 'Opgeloste referentie',
    imageNoImages: 'Geen image in de cache voor dit repository — haal er een op via OCI-images.',
    imageHeadNotCached: 'niet in de cache — opgehaald bij het starten',
    imageNoRegistries: 'Geen repository geregistreerd: registreer er een om een image te kunnen kiezen.',
    imageChosenHint: 'De image kies je met de cascade in het bewerkdialoogvenster: de referentie wordt nooit met de hand getypt.',
    registerRepositoryHint: 'Registreren downloadt niets: het maakt een repository volgbaar, zodat de image gekozen kan worden zonder dit dialoogvenster te verlaten.',
    registerRepositoryBranchHint: 'Optioneel: de eerste branch om te volgen (bijv. latest).',
    registerRepositoryElsewhere: 'Het gezochte repository is niet geregistreerd: registreren gebeurt in de sectie OCI-images, door iemand met de bevoegdheid.'
  },

  // CT-templates (ronde K2 #63): de GEMATERIALISEERDE CT-objecten — import uit
  // de catalogus is de enige ingang; de bestanden upload je in de catalogi.
  cts: {
    createAction: 'CT aanmaken',
    createTitle: 'Een container aanmaken uit een template',
    createError: 'De container is niet aangemaakt',
    template: 'CT-template',
    noTemplates: 'Geen enkel CT-template — importeer er een via CT-templates',
    resources: 'Resources',
    node: 'Node',
    phase: {
      defined: 'Nooit aan geweest',
      materializing: 'Wordt gematerialiseerd',
      ready: 'Gereed',
      starting: 'Wordt gestart',
      running: 'Draait',
      stopping: 'Wordt gestopt',
      stopped: 'Gestopt',
      deleting: 'Wordt verwijderd',
      error: 'In fout'
    },
    actions: {
      start: 'Starten',
      stop: 'Stoppen',
      restart: 'Herstarten',
      markTemplate: 'Promoveren tot CT-template',
      error: 'De actie is geweigerd'
    },
    markTemplate: {
      confirmTitle: "'{name}' promoveren tot CT-template?",
      confirmBody: "De container verlaat deze lijst en verhuist naar de CT-templates, meteen klaar om nieuwe CT's te genereren. De metadata blijven bewerkbaar en je kunt hem op elk moment terugzetten naar CT.",
      confirm: 'Promoveren',
      moved: "'{name}' is nu een CT-template — je vindt hem bij CT-templates."
    },
    stopCause: {
      api: 'Gestopt door TVirt',
      'ct-exit': 'De container is uit zichzelf gestopt',
      'host-reboot': 'Gestorven bij de herstart van de node',
      'start-failed': 'Het starten is mislukt — de fout van de task zegt wat er ontbreekt en hoe je het oplost'
    },

    console: 'Console',
    consoleUnavailable: 'De container draait niet — een console heeft een levende container nodig. De logs zijn daarentegen in elke toestand te lezen.',
    consoleNoTemplate: 'Een template draait nooit en heeft dus geen console: maak er een CT van en open die.',
    consoleConnect: 'Verbinden',
    consoleDisconnect: 'Verbinding verbreken',
    consoleReconnect: 'Opnieuw verbinden',
    consoleTakenBy: 'Een andere operator heeft deze console overgenomen ({user}). Eén console per container: opnieuw verbinden pakt hem terug.',
    consoleHint: "Klik op het zwarte vlak en typ: de toetsen komen bij de container aan. Ctrl+C en de pijltjes werken.",
    consoleEndpointDown: 'Het toegangspunt van de console kan niet worden geopend op de node die de container bedient: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'De container draait niet — een shell heeft een levende container nodig. Zijn logs zijn in elke toestand leesbaar.',
    shellNoTemplate: 'Een template draait nooit, dus heeft geen shell: maak er een CT van en open die van hem.',
    shellConnect: 'Verbinden',
    shellDisconnect: 'Verbreken',
    shellExited: 'De sessie is beëindigd met exitcode {code}.',
    shellEndedWithoutStatus: 'De sessie is beëindigd zonder exitstatus: {reason}',
    shellRevoked: 'Het ticket van de sessie is niet meer geldig — het is verlopen, of de login die het opende is ingetrokken.',
    shellHint: 'Klik in het zwarte vlak en typ: de toetsen gaan naar de container. Ctrl+C en de pijltjes werken; exit sluit de shell.',
    shellStatus: {
      connecting: 'Verbinden…',
      connected: 'Verbonden',
      ended: 'Beëindigd'
    },
    rootPassword: 'Root-wachtwoord',
    rootPasswordHint: 'Eén keer in het gekopieerde rootfs geschreven (als hash, nooit meer getoond). De images van de distributies hebben geen root-wachtwoord: zonder is de shell de enige ingang.',
    sshKeys: 'Publieke SSH-sleutels van root',
    sshKeysHint: 'Eén publieke OpenSSH-sleutel per regel, in root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Verbinden…',
      connected: 'Verbonden',
      reconnecting: 'Opnieuw verbinden…'
    },
    logs: 'Logs',
    logsTitle: 'Logs',
    logsEmpty: 'Geen output vastgelegd.',
    logsSource: 'Welk log',
    logsSourceConsole: 'De init-console van de container — waarom de dienst erin niet is gestart',
    logsSourceSupervisor: 'De liblxc-supervisor — waarom de container het nooit tot draaien heeft gebracht',
    logsNeverStarted: 'Hij is nooit gestart, dus er is nog niets vastgelegd — start hem, en de logs staan er ook als het starten mislukt.',
    logsNoTemplate: 'Een template draait nooit en heeft dus nooit iets vastgelegd.',
    logsError: 'De logs zijn niet vastgelegd',

    // Standaarddialoog (ronde #156): de tabbladen van het detail die de lijsten
    // CT en CT-templates delen, plus de sloten met het waarom erbij.
    tabs: {
      general: 'Algemeen',
      hardware: 'Hardware',
      network: 'Netwerk',
      provenance: 'Herkomst'
    },
    templateFlag: 'CT-template',
    templateLock: 'Verandert alleen via de acties Promoveren en Terugzetten naar CT — nooit via een directe wijziging.',
    sourceLock: 'Herkomst, vastgelegd bij de geboorte — nooit herschreven; een dode bron laat de referentie kaal achter.',
    storageLock: 'Vastgelegd bij de aanmaak — het verplaatsen van de rootfs is een toekomstige ronde.',
    startedAt: 'Gestart',
    lastStop: 'Laatste stop',
    editNicsTitle: 'Netwerken bewerken',
    nicDisconnected: 'losgekoppeld'
  },
  ctTemplates: {
    title: 'CT-templates',
    importAction: 'Importeren uit catalogus',
    importTitle: 'CT-template importeren uit de catalogus',
    importSubmit: 'Importeren',
    importError: 'De import is geweigerd',
    importHint: 'Materialiseren kopieert de rootfs naar de gekozen storage — het catalogusbestand blijft intact. Wil je nieuwe bestanden toevoegen, upload ze dan eerst in een catalogus.',
    sourceFile: 'CT-templatebestand',
    sourceFileHint: 'De ct-rootfs-bestanden van de gekozen catalogus, alleen degene die gereed zijn',
    noFiles: 'Geen enkel gereed ct-rootfs-bestand in deze catalogus — upload er een via de pagina van de catalogus',
    source: 'Bronbestand',
    rootfsStorage: 'Storage van de rootfs',
    rootfsStorageHint: "Waar de uitgepakte rootfs-boom leeft — een storage met bestandssysteem en voldoende vrije ruimte voor de uitgepakte grootte plus ongeveer 1 GiB marge (anders mislukt de import).",
    resources: 'Resources',
    cores: 'vCPU',
    memoryMiB: 'Geheugen (MiB)',
    cpuLimit: 'CPU-limiet',
    cpuLimitHint: 'Equivalenten van hostcores (bijv. 1.5); leeg = zonder plafond',
    cpuUncapped: 'zonder plafond',
    cpuWeight: 'CPU-gewicht',
    hostname: 'Hostname',
    hostnameHint: 'Leeg = de naam van de CT',
    nameservers: 'DNS-nameservers',
    dnsHint: "Gescheiden door komma's; leeg = neemt die van de host over",
    searchDomains: 'DNS-zoekdomeinen',
    dnsInherited: 'Overgenomen van de host',
    networks: 'Netwerken',
    nicSlot: 'NIC-slot',
    phase: {
      materializing: 'Wordt gematerialiseerd',
      ready: 'Gereed',
      deleting: 'Wordt verwijderd',
      error: 'Fout'
    },
    exportAction: 'Exporteren naar de catalogus',
    exportTitle: 'Exporteren naar de catalogus',
    exportSubmit: 'Exporteren',
    exportError: 'De export is geweigerd',
    exportHint: 'Verpakt de gematerialiseerde rootfs in een NIEUW ct-rootfs-bestand in de gekozen catalogus — het template blijft intact.',
    exportName: 'Naam van het bestand',
    exportNameHint: 'Leeg = <template>-export-<n>',
    markCt: {
      action: 'Terugzetten naar CT',
      confirmTitle: "'{name}' terugzetten naar CT?",
      confirmBody: "Het template verlaat deze lijst en keert terug in de CT-lijst, weer startbaar. Zolang je het niet opnieuw promoveert, kun je er geen CT's uit aanmaken.",
      confirm: 'Terugzetten naar CT',
      moved: "'{name}' is weer een CT — je vindt hem in de CT-lijst."
    }
  },

  // OCI golf 1 (Annex Q — het model tag-als-branch): een OCI-tag is een branch
  // (bewegende wijzer), de digest is de commit; refresh = "git fetch",
  // pull = los NU op, download DIE digest.
  oci: {
    registriesTitle: 'OCI-registries',
    imagesTitle: 'OCI-images',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Generiek',
    providerImmutableHint: 'De provider ligt na de aanmaak vast — een andere provider is een nieuwe registry.',
    url: 'URL',
    urlHintPreset: 'Vooringevuld door de provider — overschrijf hem alleen voor mirrors.',
    urlHintRequired: 'Verplicht voor generieke registries: de basis-URL met https.',
    urlHintEcr: 'Verplicht: ECR-endpoints zijn per account en per regio — er bestaat geen preset.',
    credential: 'Credential',
    credentialNone: 'Anonieme toegang',
    credentialHint: 'Een keystore-item met gebruikersnaam en wachtwoord; de workers lossen hem op bij gebruik — nooit een auth file per node.',
    nameHint: 'Naam in hostvorm (docker.io, registry.intra); uniek per scope, ligt vast',
    addRegistry: 'Registry toevoegen',
    addRegistryTitle: 'OCI-registry toevoegen',
    verify: 'Verifiëren',
    verifyState: 'Verificatie',
    verified: 'Geverifieerd',
    verifyFailed: 'Mislukt',
    neverVerified: 'Nooit geverifieerd',
    registryInUseError: "'{name}' heeft nog geregistreerde repository's — verwijder die eerst.",
    repositories: "Repository's",
    repositoriesHint: 'Registreren observeert de branches (OCI-tags) — het downloadt niets. De refresh lost elke geobserveerde branch op en houdt de reflog bij.',
    noRepositories: "Geen enkele repository geregistreerd op deze registry.",
    registerRepository: 'Repository registreren',
    repoPath: 'Pad',
    repoPathHint: "Pad van de repository op de registry, bijv. 'example' of 'library/nginx'",
    branches: 'Branches',
    branchesHint: "Geobserveerde branches (OCI-tags), gescheiden door komma's — bijv. 1.1.0, 1.1.1",
    branch: 'Branch',
    branchPullHint: 'NU opgelost: de pull haalt de digest op waar de branch vandaag naar wijst.',
    refresh: 'Bijwerken',
    deleteRepository: 'Repository verwijderen',
    reflogCount: '{n} eerdere',
    noResolutions: 'Nooit bijgewerkt — geen enkele geobserveerde resolutie.',
    refreshFailed: 'Laatste bijwerking mislukt ({when})',
    loadError: "Kan de repository's niet laden.",
    reference: 'Referentie',
    digest: 'Digest',
    digestHint: 'sha256:… — de exacte image, zonder branch (detached)',
    size: 'Grootte',
    nodes: 'Nodes',
    detached: 'detached',
    detachedHint: 'Opgehaald per digest, zonder branch — de driftcontrole is niet van toepassing.',
    pulledAt: 'Opgehaald',
    pull: 'Pull',
    pullTitle: 'Image pullen',
    pullHint: 'Pre-warming, nooit een vereiste: een pull per branch lost NU op en haalt DIE digest op; een pull per digest is detached.',
    pullError: 'De pull is geweigerd',
    pullMode: 'Pull per',
    pullModeBranch: 'Branch (nu oplossen)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'De eerlijke default: net als apt install kan hij later opnieuw uitgevoerd een andere image opleveren.',
    pullModeDigestHint: 'Exacte digest — reproduceerbaarheid en rollback; je doet afstand van de driftcontrole.',

    // Het patroon met twee knoppen (#88, bekrachtigd 2026-07-30 's avonds):
    // "uit registry" is de bestaande begeleide pull, "uit catalogus"
    // materialiseert een kant-en-klaar oci-image-archief (de air-gapped weg).
    importFromRegistry: 'Importeren uit registry',
    importFromCatalog: 'Importeren uit catalogus',
    importCatalogTitle: 'OCI-image importeren uit de catalogus',
    importCatalogHint: 'De air-gapped weg: een kant-en-klaar oci-image-archief (tar/tar.gz — docker-archive of oci-archive) wordt in de imagestore gematerialiseerd met de referentie catalog/<catalogus>/<bestand>@<digest>; de apps gebruiken het als elke andere image. Archieven upload je in de catalogi — deze sectie importeert alleen.',
    importCatalogFile: 'Archief',
    importCatalogFileHint: 'De gereede oci-image-bestanden van de gekozen catalogus.',
    importCatalogNoFiles: 'Geen enkel gereed oci-image-archief in deze catalogus — upload er een via het detail van de catalogus.',
    importCatalogError: 'De import is geweigerd',
    registry: 'Registry',
    repository: 'Repository',
    cacheMissing: 'De OCI-cache van het cluster is niet geconfigureerd — pulls worden geweigerd zolang je geen storage-pool instelt.',
    setCache: 'Cache instellen',
    setCacheTitle: 'De OCI-cache configureren',
    setCacheHint: 'De DEFAULT pool op clusterniveau die de blobs van de opgehaalde images herbergt — een scope kan daaroverheen een eigen pool zetten (pagina Scopes). Wijzigen gaat niet warm in, herstart niets en verplaatst de blobs niet: die verschijnen lazy weer bij de volgende start of het volgende gebruik.',
    cachePool: 'Storage-pool',
    changeCache: 'Cache wijzigen',
    changeCacheTitle: 'De pool van de OCI-cache wijzigen',
    cacheCurrent: 'OCI-cache van het cluster (default): {name}',
    sectionOverview: 'Overzicht',
    sectionRepositories: "Repository's",
    sectionExplore: 'Verkennen',
    exploreHint: 'Live zoeken op afstand in de registry — Docker Hub volledig (beschrijving, downloads, sterren), andere providers naar beste vermogen. Selecteer een resultaat om de volledige beschrijving te lezen en door de remote tags te bladeren; vanaf een tag kun je de referentie toevoegen aan een TVirt-repository.',
    exploreSearch: 'Zoeken',
    exploreUnsupported: 'Deze provider ondersteunt zoeken niet.',
    exploreNoResult: 'Geen overeenkomende repository.',
    exploreNoTags: 'Geen overeenkomende tag in deze repository.',
    exploreOfficial: 'Officieel',
    explorePulls: 'Downloads',
    exploreStars: 'Sterren',
    exploreUpdated: 'Bijgewerkt {when}',
    exploreLoadMore: 'Meer laden',
    exploreSelectHint: 'Selecteer een resultaat: de volledige beschrijving en de remote tags laden hier.',
    exploreNoDescription: 'Geen beschrijving beschikbaar van deze provider.',
    exploreTagsTitle: 'Remote tags',
    exploreTagFilter: 'Tag zoeken',
    exploreAddToRepo: 'Toevoegen aan repository',
    exploreAdded: "{path}:{tag} wordt nu gevolgd — zie de sectie Repository's.",
    addBranch: 'Branch toevoegen',
    purgeRequiredTitle: "'{name}' en zijn images verwijderen?",
    purgeRequiredBody: 'Geen enkele app gebruikt deze repository, maar er bestaan nog gedownloade images: verwijderen wist ook hun records, en de gecachte blobs gaan naar de garbage collection.',
    purgeConfirm: 'Ook de images verwijderen',
    providerSelectHint: 'Kies het registry-type: de kaart vertelt de preset en het gebruik.',
    providerDesc: {
      dockerhub: 'De publieke Docker-registry: URL vooraf ingevuld, volledige zoekfunctie met beschrijvingen en tellers.',
      ghcr: 'GitHub Container Registry: URL vooraf ingevuld; accounts gebruiken een personal access token.',
      ecr: 'Amazon Elastic Container Registry: endpoints per account/regio — de URL moet worden opgegeven.',
      quay: 'De Red Hat Quay-registry: URL vooraf ingevuld.',
      generic: 'Self-hosted registry (Harbor, registry:2, …): de https://-URL is verplicht.'
    },

    // Standaarddialoog (ronde #156): de velden van het image- en
    // registrydetail die de kolommen niet lieten zien.
    layerCount: 'Layers',
    verifiedAt: 'Laatste verificatie',
    verifyOk: 'Uitkomst',
    verifyMessage: 'Verificatiebericht',

    // Het model #348/R39: de image IS de digest — de inhoud — en registry, repository en branch zijn de NAMEN die hem bereiken.
    head: 'Head',
    heads: 'Heads per architectuur',
    listDigest: 'Digest van de lijst',
    neverResolved: 'Nooit opgelost',
    totalSize: 'Totale grootte',
    reflogTitle: 'Resolutiegeschiedenis',
    usedBy: 'Gebruikt door',
    usageLockfile: 'lockfile',
    usageRunning: 'draait',
    evictable: 'verwijderbaar',
    evict: 'Uit de cache verwijderen',
    evictHeadTitle: '{digest} verwijderen?',
    evictHeadBody: 'Het is de huidige resolutie van minstens één verzamelaar: verwijderen mag — het is alleen cache, de externe branch levert hem nog steeds — maar het mag nooit per ongeluk gebeuren. De blob is ÉÉN: de verwijdering leegt elke verzamelaar die hem deelt.',
    evictConfirm: 'Toch verwijderen',

    arch: 'Architectuur',
    names: 'Namen',
    noNames: 'geen naam',
    views: 'Views',
    lastView: 'laatste view',
    evictLastViewTitle: 'De laatste verwijzing naar {digest} verwijderen?',
    evictLastViewBody: 'Dit is de laatste view op deze inhoud: verwijder je hem, dan houdt de image op te bestaan op TVirt en komen de bytes ({size}) vrij. Het is de docker image rm van het model — geen neveneffect, maar de bewerking zelf.',
    branchesTabHint: 'De waargenomen branches van dit repository: per branch de heads van vandaag — één per architectuur — de chronologie van de refreshes en hoeveel van de images die hij noemde in de cache staan. De refresh is de «git fetch» van het repository: hij resolvet al zijn branches in één keer.',
    noBranches: 'Geen branch waargenomen op dit repository.',
    stopObserving: 'Branch niet meer volgen',
    pullBranch: 'De head van de branch in de cache halen (de refresh lost op, deze downloadt)',
    pullDigest: 'Deze digest in de cache halen',
    imageCount: 'Images',
    deleteBranchPurgeTitle: 'De images van {name} zonder naam laten?',
    deleteBranchPurgeBody: 'Geen enkele app noemt deze branch, maar sommige images worden alleen via hem bereikt: verwijder je hem, dan blijven ze naamloos in de cache, vermeld bij de images van het repository en met de hand te verdringen.',
    deleteBranchPurgeConfirm: 'Verwijderen en images zonder naam laten',
    imagesTabHint: 'De images van dit repository — de inhoud, dus de digests — ook zichtbaar zonder een branch te kiezen. Een image is uniek per cluster: de namen die hem bereiken kunnen er meerdere zijn.',
    noImages: 'Geen image van dit repository is in de cache gematerialiseerd.',
    deleteRepositoryTitle: '{name} verwijderen?',
    deleteRepositoryBody: 'Het repository en zijn branches verdwijnen, met hun chronologie. De images blijven in de cache: ze verliezen alleen deze naam. Een repository dat een app noemt, kan niet worden verwijderd.',
    provenanceCatalog: 'catalogus',
    refreshedAt: 'Bijgewerkt',
    neverRefreshed: 'Nooit bijgewerkt',
    sectionBranches: 'Branches',
    sectionImages: 'Images',
    repositoriesGovernedElsewhere: 'Hier worden repositories alleen bekeken: registreren, bijwerken, branches volgen en images verdringen gebeurt in de sectie OCI-images.',
    gotoImages: 'Naar OCI-images'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pods',
    containers: 'Containers',
    instances: 'Instanties',
    instancesTooltip: '{running} actief, {error} in fout',
    placement: 'Plaatsing',
    spread: 'spreiding',
    ha: 'HA',
    templateRevision: 'revisie',
    deleting: 'Wordt verwijderd',
    empty: 'Geen pods — maak een app (één container) of een pod via de CLI (create-pod).',
    openInstances: 'Instanties openen',
    rollingRestart: 'Rollende herstart',
    scale: 'Schalen',
    scaleTitle: '{name} schalen',
    scaleHint: 'Aantal instanties (0–64): omhoog vult het laagste vrije rangnummer, omlaag trekt het hoogste terug en de persistente gegevens blijven.',
    scaleError: 'Schalen mislukt',
    replicas: 'Replica’s',
    deleteRunningError: '{name} draait — stop hem eerst.',
    deleteInstancesIntro: 'Alle {count} instanties worden verwijderd.',
    stateRunning: 'Actief',
    stateStopped: 'Gestopt',
    editor: {
      createTitle: 'Pod aanmaken',
      create: 'Pod aanmaken',
      editTitle: 'Pod bewerken',
      nameHint: 'DNS-1123, hoogstens 58 tekens — de instanties heten <naam>-<index>; onveranderlijk na aanmaak.',
      restartPolicy: 'Herstartbeleid',
      restartPolicyHint_always: 'Het knooppunt herstart elke gestopte container, met exponentiële backoff (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Alleen een container met een exitcode ongelijk aan nul wordt herstart; exit 0 blijft rusten.',
      restartPolicyHint_never: 'Een gestopte container blijft zoals hij is — de instantie eindigt als succeeded of failed.',
      grace: 'Respijt (s)',
      graceHint: 'De SIGTERM → SIGKILL-grens van een stop.',
      hostname: 'Hostnaam',
      hostnameHint: 'Leeg = de instantienaam.',
      hostnameDefault: 'de instantienaam',
      sharePid: 'PID-namespace delen tussen de containers',
      containersIntro: 'Init-containers draaien op volgorde tot het einde voordat de containers starten; de containers delen het netwerk van de instantie (één IP, localhost onderling).',
      initContainers: 'Init-containers',
      initAdd: 'Init-container toevoegen',
      initHint: 'Elk moet met 0 eindigen; een mislukking zet de instantie op fout en het knooppunt probeert opnieuw met backoff.',
      containerAdd: 'Container toevoegen',
      atLeastOne: 'Een Pod heeft minstens één container nodig.',
      duplicateNames: 'Containernamen moeten uniek zijn binnen de Pod (init-containers inbegrepen).',
      containerName: 'Containernaam',
      containerInvalid: 'Deze container is onvolledig: naam (DNS-1123), image, mounts op gedeclareerde volumes, numerieke limieten en probe.',
      command: 'Opdracht',
      commandHint: 'Overschrijft het entrypoint van de image — één argument per regel, nooit een shell-string.',
      args: 'Argumenten',
      argsHint: 'Eén per regel (de CMD van de image indien leeg).',
      mounts: 'Mounts',
      mountAdd: 'Mount toevoegen',
      mountNoVolumes: 'Declareer eerst een volume in het tabblad Opslag.',
      readOnly: 'alleen-lezen',
      resources: 'Limieten',
      cpus: 'CPU\'s',
      cpusHint: 'podman --cpus (bv. 1.5)',
      memory: 'Geheugen (MiB)',
      memoryHint: 'podman --memory',
      health: 'Liveness-probe',
      healthCmd: 'Probe-opdracht',
      healthCmdHint: 'Door het knooppunt in de container uitgevoerd bij elke supervisietik — één argument per regel; exit 0 = gezond.',
      healthTimeout: 'Time-out (s)',
      healthRetries: 'Pogingen',
      healthRetriesHint: 'Opeenvolgende mislukkingen voordat het knooppunt de container herstart.',
      ips: 'Statische adressen',
      ipsHint: 'Eén per instantie, in ordinale volgorde — schalen voorbij de lijst wordt geweigerd.',
      instance: 'instantie',
      volumesHint: 'Volumes zijn van de Pod; het mountpad is van elke container (tabblad Containers).',
      spread: 'Spreiding',
      spreadHint_preferred: 'Instanties waar mogelijk op verschillende knooppunten.',
      spreadHint_required: 'Instanties op verschillende knooppunten, anders weigert het schalen.',
      spreadHint_none: 'Alleen de beslisser.',
      ha: 'Hoge beschikbaarheid (opt-in)',
      haHint: "Elk persistent deel op gedeelde storage; als de node sterft, maakt de HA-decider de instanties opnieuw aan op een ander lid (automatische failover, zoals HA-VM's).",
      yes: 'ja',
      no: 'nee'
    },
    detail: {
      container: 'Container',
      actions: 'Acties',
      ready: 'Gereed',
      notReady: 'Niet gereed',
      restarts: 'Herstarts',
      lastRestartAt: 'Laatste herstart:',
      backoffUntil: 'Opnieuw om',
      stateAbsent: 'afwezig',
      stateRunning: 'actief',
      stateTerminated: 'beëindigd',
      stateWaiting: 'wachtend',
      init: 'init',
      noInstances: 'Geen instanties (replica\'s 0).',
      ha: 'HA',
      haHint: 'Automatische failover: als de node sterft, maakt de HA-decider de instantie opnieuw aan op een ander lid (elk persistent deel op gedeelde storage).',
      authority: 'Authority (node)',
      homeless: 'zonder authority',
      homelessHint: "Een herstel vanuit een checkpoint laat de authority buiten beschouwing (#380): geen node bedient hem tot je de Pod schaalt (ook naar hetzelfde aantal replica's).",
      restartContainer: 'Alleen deze container herstarten (de pod blijft draaien)',
      divergingHint: 'De gewenste toestand van deze instantie wijkt af van de standaard van de Pod (PD-P19).',
      revisionLag: 'revisie {applied} toegepast van {current}',
      updatedInstances: '{updated}/{desired} instanties op deze revisie'
    }
  }
}
